import React from 'react';
import T from 'prop-types';

import ThresholdBadge from '../../../../../components/ThresholdBadge';

const ForecastsCollapsed = ({
  forecasts,
}) => (
  <div className="forecasts-main-collapsed">
    <div className="forecasts-main-collapsed__item">
      <div className="forecasts-main-collapsed__stats">
        <div className="forecasts-main-collapsed__stats-left-head">
          KPI
        </div>
      </div>
      <div className="forecasts-main-collapsed__values">
        <div className="forecasts-main-collapsed__values-item-head">
          Forecast
        </div>
        <div className="forecasts-main-collapsed__values-item-head">
          Chg in Forecast
        </div>
        <div className="forecasts-main-collapsed__values-item-head">
          Consensus
        </div>
        <div className="forecasts-main-collapsed__values-item-head">
          Delta to Cons
        </div>
      </div>
    </div>
    {forecasts.map((
      {
        kpi_name,
        forecasts: {
          forecast_yoy,
          delta,
          change,
          consensus_yoy,
        },
      }) => (
        <div key={kpi_name} className="forecasts-main-collapsed__item">
          <div className="forecasts-main-collapsed__stats">
            <div className="forecasts-main-collapsed__stats-left">
              {kpi_name}
            </div>

          </div>
          <div className="forecasts-main-collapsed__values">
            <div className="forecasts-main-collapsed__values-item">
              <ThresholdBadge
                value={forecast_yoy || '-'}
                valueUnit={<span>% <span className="value-caption">YoY</span></span>}
              />
            </div>
            <div className="forecasts-main-collapsed__values-item">
              <ThresholdBadge
                value={change || '-'}
                valueUnit="%"
              />
            </div>
            <div className="forecasts-main-collapsed__values-item">
              <ThresholdBadge
                value={consensus_yoy || '-'}
                valueUnit={<span>% <span className="value-caption">YoY</span></span>}
              />
            </div>
            <div className="forecasts-main-collapsed__values-item">
              <ThresholdBadge
                value={delta}
              />
            </div>
          </div>
        </div>
    ))}
  </div>
);
ForecastsCollapsed.propTypes = {
  forecasts: T.array,
};

export default ForecastsCollapsed;
